import api from './api'
import enums from '@/api/enums'
import siteVersions from '../site-versions/api'

export default {
  namespaced: true,
  state: {
    routeKey: 'productId',
    routes: {
      index: 'products.index',
      create: 'products.create',
      edit: 'products.edit'
    },
    table: [
      { code: 'site_versions', type: 'function', get: data => data.map(item => item.name).join(', ') },
      { code: 'publish', type: 'boolean' },
      { code: 'code', type: 'string', sort: true },
      { code: 'name', type: 'string', sort: true },
      { code: 'type', type: 'function', get: data => data?.description },
      { code: 'created_at', type: 'datetime', sort: true },
      { code: 'updated_at', type: 'datetime', sort: true }
    ],
    form: [
      { code: 'site_versions', type: 'multiselect', options: [], size: 6, validation: { required: true } },
      { code: 'publish', type: 'boolean' },
      { code: 'weight', type: 'array', keys: [] },
      { code: 'code', type: 'text', validation: { required: true } },
      { code: 'name', type: 'text', validation: { required: true } },
      { code: 'type', type: 'select', options: [], validation: { required: true, integer: true } },
      { code: 'description', type: 'textarea' },
      { code: 'composition', type: 'textarea' },
      { code: 'nutritional', type: 'textarea' }
    ],
    item: {},
    items: [],
    meta: {},
    page: 1,
    sort: 'id'
  },
  mutations: {
    SET_ITEMS (state, data) {
      state.items = data.data
      state.meta = data.meta
    },
    SET_ITEM (state, data) {
      state.item = {
        id: data.id || null,
        locales: data.locales || [],
        site_versions: data.site_versions?.map(item => item.id) || [],
        publish: data.publish === true ? 1 : null,
        weight: data.weight || null,
        code: data.code || null,
        name: data.name || null,
        type: data.type?.value || null,
        description: data.description || null,
        composition: data.composition || null,
        nutritional: data.nutritional || null
      }
    },
    SET_SELECT_OPTIONS (state, { code, options }) {
      state.form.find(item => item.code === code).options = options
    },
    SET_FIELD_KEYS (state, { code, keys }) {
      state.form.find(item => item.code === code).keys = keys
    },
    SET_SORT (state, field) {
      state.sort = state.sort === field ? `-${field}` : field
    },
    SET_PAGE (state, page) {
      state.page = page
    }
  },
  actions: {
    async fetchItems ({ commit, state }) {
      const { data } = await api.index({
        'sort': state.sort,
        'page[number]': state.page
      })

      commit('SET_ITEMS', data)
    },
    clearItems ({ commit }) {
      commit('SET_ITEMS', {})
    },
    async fetchItem ({ commit }, { route }) {
      const { data: { data } } = await api.show(route.params.productId)

      commit('SET_ITEM', data)
    },
    clearItem ({ commit }) {
      commit('SET_ITEM', {})
    },
    async fetchEnums ({ commit }) {
      const { data } = await enums.index()

      const options = data.productTypes?.map(item => ({
        value: item.value,
        text: item.description
      }))

      commit('SET_SELECT_OPTIONS', { code: 'type', options })
    },
    async fetchSiteVersions ({ commit }) {
      const { data: { data } } = await siteVersions.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'site_versions', options })

      const keys = data.map(item => ({
        code: item.id,
        label: item.name
      }))

      commit('SET_FIELD_KEYS', { code: 'weight', keys })
    },
    async createItem ({ commit }, { form }) {
      const { data: { data } } = await api.store(form)

      commit('SET_ITEM', data)
    },
    async updateItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.update(route.params.productId, form)

      commit('SET_ITEM', data)
    },
    async deleteItem ({ commit }, { id }) {
      await api.destroy(id)
    }
  }
}
